module.exports = __webpack_public_path__ + "static/media/center-web.13175193.svg";